// Sale model line
import ModalTags from "components/Modals/ModalTags";
import { PlusCircleIcon } from "components/Icons";

const getProduct = (value) => {
  const search = [
    "OR",
    [
      ["template.name", "ilike", `%${value}%`],
      ["template.salable", "=", true],
    ],
    [
      ["code", "ilike", `${value}%`],
      ["template.salable", "=", true],
    ],
  ];
  return search;
};

const onChangeProduct = async (record, store) => {
  if (record.product) {
    const product = record.product;
    let unit = product["sale_uom."];
    let unit_price;
    if (product["sale_uom."] !== product["sale_uom."]) {
      // FIXME get price according to sale uom
      unit_price = product.list_price;
    } else {
      unit_price = product.list_price;
    }
    unit_price = parseFloat(unit_price.toString());
    store.unit_price = unit_price;
    store.unit = unit.id;
    store.product = product.id;
    record.unit_price = unit_price;
    record.unit = unit;
    record.amount = unit_price * record.quantity;
    record.sale_price_taxed = record.product.sale_price_taxed * record.quantity;
  }
};

const onChangeQty = (record) => {
  const amount = (record.unit_price || 0) * record.quantity || 0;
  record.amount = amount;
};

const searchUnit = (value, record) => {
  let dom = [["category", "=", record?.unit?.category]];
  if (value) {
    dom.push(["name", "ilike", `%${value}%`]);
  }
  return dom;
};

const getTotalAmount = (record) => {
  let res = 0;
  if (record.sale_price_taxed && record.quantity) {
    res = record.sale_price_taxed * record.quantity;
  }
  return res;
};

const recReadOnly = (record) => {
  let res = false;
  if (record.status_order !== "draft") {
    res = true;
  }
  return res;
};

const getDisabled = (record) => record?.status_order !== "draft";

function accDelete(rec) {
  return rec.status_order === "draft";
}

function accEdit(rec) {
  return rec?.status_order === "draft";
}
const visibleButton = (name, record) => {
  console.log("visibleButton", record);

  return record.product.tags && record.product.tags.length > 0;
};

const getView = (config) => {
  Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
  };
  const attrsProduct = [
    "id",
    "list_price",
    "name",
    "sale_price_taxed",
    "sale_uom.rec_name",
    "default_uom.rec_name",
  ];
  if (config.productTagActive) {
    attrsProduct.push("tags.name");
  }
  let DictCtxView = {
    model: "sale.line",
    table_action: ["edit"],
    form_action: ["delete", "add", "edit"],
    access: {
      delete: accDelete,
      edit: accEdit,
    },
    target: "sale",
    readOnly: recReadOnly,
    webfields: {
      product: {
        type: "many2one",
        recName: "name",
        model: "product.product",
        recSearch: getProduct,
        withChange: onChangeProduct,
        attrs: attrsProduct,
        required: true,
        readOnly: getDisabled,
      },
      unit: {
        type: "many2one",
        model: "product.uom",
        recSearch: searchUnit,
        readOnly: true,
        attrs: ["id", "name", "category", "factor"],
      },
      quantity: {
        type: "integer",
        withChange: onChangeQty,
        required: true,
        default: 1,
        readOnly: getDisabled,
      },
      amount_w_tax: {
        type: "numeric",
        readOnly: true,
      },
      status_order: {
        type: "char",
        readOnly: true,
        default: "draft",
        translate: true,
      },
      total_amount: {
        type: "numeric",
        readOnly: true,
        function: getTotalAmount,
      },
      tag: {
        type: "button_custom_modal",
        Component: ModalTags,
        color: "blue",
        visible: visibleButton,
        content: "ADD TAG",
        icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
      },

      note: { type: "text", readOnly: getDisabled },
    },
    webtree: [
      { name: "product", width: "40%" },
      { name: "quantity", width: "10%" },
      { name: "amount_w_tax", width: "20%" },
      // { name: "total_amount", width: "20%" },
      { name: "note", width: "10%" },
      { name: "status_order", width: "10%" },
      { name: "tag", width: "10%" },
    ],
    webform: [
      { name: "product" },
      { name: "quantity" },
      { name: "note" },
      { name: "amount_w_tax" },
      { name: "total_amount" },
      { name: "status_order" },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
